import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_ask_dialog = _resolveComponent("ontos-ask-dialog")!

  return (_openBlock(), _createBlock(_component_ontos_ask_dialog, {
    title: _ctx.$tt('relationship-unlink-confirm', _ctx.names),
    message: _ctx.$tt('relationship-unlink-explain', _ctx.names),
    actions: _ctx.actions,
    onPick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onPicked($event))),
    onClosed: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('closed')))
  }, null, 8, ["title", "message", "actions"]))
}